import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

interface PrivateRouteProps {
  session: any
  allowedRoles?: number[]
}

export const PrivateRoute = ({ session, allowedRoles }: PrivateRouteProps) => {
  const location = useLocation()
  const isAuthorizedSession = (
    session?.sessionData &&
    session?.sessionData?.user &&
    session?.sessionData?.user['id'] > 0 &&
    session?.sessionData?.roles &&
    session?.sessionData?.roles.length > 0
  )

  const hasRequiredRole = (roles: number[], allowedRoles?: number[]) => {
    if (!allowedRoles || allowedRoles.length === 0) {
      return true
    }
    return roles.some(role => allowedRoles.includes(role))
  }

  if (!isAuthorizedSession) {
    return <Navigate to={`/login?from=${encodeURIComponent(location.pathname + location.search)}`} replace />
  }

  const userRoles = session?.sessionData?.roles || []
  if (!hasRequiredRole(userRoles, allowedRoles)) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
